@if (cardInfo) {
    <div class="header">
        <div class="left">
            <h2 class="title headline-bold">{{ cardInfo.title }}</h2>
            @if (dateInterval) {
                <div></div>
            }
            <web-fading-span
                [value]="dateInterval?.displayedDate"
                valueClass="grey subtitle sub-headline-bold"
            ></web-fading-span>
        </div>
        <ion-icon [src]="'assets/icon/card/' + cardInfo.icon"></ion-icon>
    </div>
}

<ng-content select="[chart]"></ng-content>

<ng-content></ng-content>
